export default __webpack_public_path__ + "static/maintenance-70d18b73ceabc615cb5bf2903ecaeccd.svg";